import React, { useRef } from 'react';
import { FaMap, FaToolbox, FaUsers } from 'react-icons/fa';
import { GiDeerTrack, GiCampfire } from 'react-icons/gi';
import { AuthBrandGridGlow } from './AuthBrandGridGlow';
import { isCampEssentialsEnabled } from '../../../utils/featureFlags';
import '../styles/auth-design.css';

const YONA_BRAND_MARK_SRC = `${process.env.PUBLIC_URL || ''}/brand/yona-bear-2.png`;

function getAuthFeatures() {
  const features = [
    { icon: FaMap, label: 'Get your own personal map and shared club maps to tag out' },
    { icon: FaToolbox, label: 'Planting Assistant to help get the fields right; Feed Tracker to keep up with all that corn' },
    { icon: FaUsers, label: 'Holler at your Hunting buddies with direct messages and simple hunt-based profiles' },
    { icon: GiDeerTrack, label: 'Log your hunts, manage your stands, and view stats from year to year' },
  ];
  if (isCampEssentialsEnabled()) {
    features.push({
      icon: GiCampfire,
      label: 'Camp recipes, outdoor marketplace, and fireside fun',
    });
  } else {
    features.push({
      icon: GiCampfire,
      label: 'Check out the club board, calendar, or find a club to join',
    });
  }
  return features;
}

export function AuthBrandPanel() {
  const panelRef = useRef(null);
  const features = getAuthFeatures();

  return (
    <aside className="auth-brand" ref={panelRef} aria-hidden="true">
      <div className="auth-brand__fallback-bg" />
      <img
        className="auth-brand__photo"
        src="/images/landing-forest.jpg"
        alt=""
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
      <div className="auth-brand__gradient" />
      <div className="auth-brand__grid" />
      <AuthBrandGridGlow containerRef={panelRef} />
      <span className="auth-brand__bracket-tl" />
      <span className="auth-brand__bracket-br" />

      <div className="auth-brand__content auth-brand__logo-row">
        <span className="auth-brand__logo-chip">
          <img src={YONA_BRAND_MARK_SRC} alt="Yona" className="auth-brand__logo-img" />
        </span>
        <div>
          <div className="auth-brand__wordmark">YONA</div>
          <div className="auth-brand__tagline">LOVE THE LAND</div>
        </div>
      </div>

      <div className="auth-brand__content">
        <div className="auth-brand__eyebrow"></div>
        <h2 className="auth-brand__headline">The Hunting Club App of the South</h2>
        <p className="auth-brand__body">
          Manage the club with an app built for the Southern way of hunting. Use them other fellas for your western excursions.
        </p>
        <div className="auth-brand__features">
          {features.map(({ icon: Icon, label }) => (
            <div key={label} className="auth-brand__feature">
              <span className="auth-brand__feature-icon">
                <Icon size={14} />
              </span>
              {label}
            </div>
          ))}
        </div>
      </div>

      <div className="auth-brand__footer">
        <span>34.1484N | 87.4045W</span>
        <span>EST. 2026 · ALABAMA</span>
      </div>
    </aside>
  );
}
